import {Injectable} from '@angular/core';
import {JsonApiService} from '../../../../core/api/json-api.service';

@Injectable()
export class ActivitiesService {

    url: string;

    constructor(private jsonApiService: JsonApiService) {
        this.url = '/activities/activities.json';
    }

    getActivities() {
        return this.jsonApiService.fetch(this.url)
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/activities.service.ts